import { render, staticRenderFns } from "./DvSelect.vue?vue&type=template&id=bdd069b0&lang=pug"
import script from "./DvSelect.vue?vue&type=script&lang=js"
export * from "./DvSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports